/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_No_PostsInputs */

const en_blog_no_posts = /** @type {(inputs: Blog_No_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No posts yet, check back soon.`)
};

/**
* | output |
* | --- |
* | "No posts yet, check back soon." |
*
* @param {Blog_No_PostsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const blog_no_posts = /** @type {((inputs?: Blog_No_PostsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_No_PostsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_blog_no_posts(inputs)
});
export { blog_no_posts as "blog.no_posts" }